<div class="proDetailsView">
    <div class="first-section-wrapper" *ngIf="loading">
        <div fxFlex.gt-md="35">
            <ngx-skeleton-loader appearance="circle"
                [theme]="{width: '450px', height: '350px', 'border-radius': '10px'}">
            </ngx-skeleton-loader>
        </div>
        <div fxFlex.gt-md="65">
            <div>
                <ngx-skeleton-loader
                    [theme]="{ width: '500px', 'border-radius': '0', height: '45px','margin-top': '30px', 'margin-bottom': '30px'}">
                </ngx-skeleton-loader>
            </div>
            <div>
                <ngx-skeleton-loader
                    [theme]="{ width: '250px', 'border-radius': '0', height: '25px', 'margin-bottom': '30px'}">
                </ngx-skeleton-loader>
            </div>
            <div>
                <ngx-skeleton-loader
                    [theme]="{ width: '100px', 'border-radius': '0', height: '25px', 'margin-bottom': '30px'}">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>
    <div fxLayout="row wrap" *ngIf="!loading">
        <div fxFlex="100" fxFlex.gt-md="35" fxFlex.md="45">
            <mat-card class="product-image" *ngIf="product">
                <mat-chip-list class="list-view wid-40 zindex" fxLayoutAlign="end">
                    <mat-chip color="warn" class="design" selected="true"
                        *ngIf="product && !!product['product']['featured_product']">
                        FEATURED</mat-chip>
                    <mat-chip class="newItem design" selected="true"
                        *ngIf="product && !!product['product']['new_arrival']">
                        NEW!
                    </mat-chip>
                </mat-chip-list>
                <mat-chip-list *ngIf="product?.discount">
                    <mat-chip color="warn" selected="true">{{product?.discount}}% OFF</mat-chip>
                </mat-chip-list>
                <div class="Probadges" *ngIf="product['product']['cb_product_badges']" [ngClass]="{ 'ProbadgeImgFit': FeatureTagProbadgeImgFit }">
                    <ul>
                        <li *ngFor="let badge of product['product']['cb_product_badges']">
                            <img [src]="badge['cb_badge']['image'] | mapUrlForImg" alt="badges">
                        </li>
                    </ul>
                </div>
                <button mat-icon-button (click)="openZoomViewer()" fxHide="false" fxHide.gt-md
                    *ngIf="product && mainImage !== 'assets/images/no_image_found_md.png'">
                    <mat-icon
                        *ngIf="product && mainImage !== 'assets/images/no_image_found_md.png'">fullscreen</mat-icon>
                </button>
                <!-- <img *ngIf="product" class = "zoom" fxHide="false" fxHide.gt-md [src]="mainImageName" [imgName]="mainImageName" imgType="singleProduct" 
                    imgSize="md" imagePreload alt = "{{product['product']['description']}}"  (mousemove)="onMouseMove($event, 3)" (mouseleave)="onMouseLeave($event)" />
                <img *ngIf="product && !!product['product']['product_image1'] === false"  fxShow="false" fxShow.gt-md [src]="mainImageName" [imgName]="mainImageName" imgType="singleProduct" 
                    imgSize="md" imagePreload alt = "{{product['product']['description']}}"  (mousemove)="onMouseMove($event, 3)" (mouseleave)="onMouseLeave($event)" /> -->
                <ng-container *ngIf="!!featureTags && featureTags['sf_product_img_slider']">
                    <ng-container *ngIf="!!featureTags && featureTags['sf_seo']; else zoomProduct">
                        <ng-container *ngIf="!!featureTags && !featureTags['sf_product_img_zoomer']">
                            <img *ngIf="product && mainImage !== 'assets/images/no_image_found_md.png'" class="product-fit-img cursorAuto" [src]="mainImage"
                                (error)="setDefaultPic()" alt="{{product['product']['description']}}"/>
                            <img *ngIf="product && mainImage === 'assets/images/no_image_found_md.png'" (error)="setDefaultPic()"
                                class="product-fit-img cursorAuto" [src]="mainImage" alt="{{product['product']['description']}}"/>
                        </ng-container>
                        <ng-container *ngIf="!!featureTags && featureTags['sf_product_img_zoomer']">
                            <img *ngIf="!isBrowser && product && mainImage !== 'assets/images/no_image_found_md.png'" class="product-fit-img cursorAuto" [src]="mainImage"
                                (error)="setDefaultPic()" alt="{{product['product']['description']}}"/>
                            <img *ngIf="product && mainImage === 'assets/images/no_image_found_md.png'" (error)="setDefaultPic()"
                                class="product-fit-img cursorAuto" [src]="mainImage" alt="{{product['product']['description']}}"/>
                            <lib-ngx-image-zoom *ngIf="isBrowser && product && mainImage !== 'assets/images/no_image_found_md.png'"
                            [thumbImage]=mainImage [fullImage]=fullImage [magnification]="1.5" fxShow="false" fxShow.gt-md
                            [enableScrollZoom]="true" [enableLens]="true" [lensWidth]="200"></lib-ngx-image-zoom>
                            <img *ngIf="isBrowser && product && mainImage !== 'assets/images/no_image_found_md.png'" class="zoom product-fit-img"
                                fxHide="false" fxHide.gt-md [src]="mainImage" (error)="setDefaultPic()" alt="{{product['product']['description']}}"
                                (mousemove)="onMouseMove($event, 3)" (mouseleave)="onMouseLeave($event)" />
                        </ng-container>
                    </ng-container>
                    <ng-template #zoomProduct>
                    <img *ngIf="product" class="zoom product-fit-img" fxHide="false" fxHide.gt-md [src]="mainImage"
                        (error)="setDefaultPic()" alt="{{product['product']['description']}}"
                        (mousemove)="onMouseMove($event, 3)" (mouseleave)="onMouseLeave($event)" />
                    <img *ngIf="product && mainImage === 'assets/images/no_image_found_md.png'" (error)="setDefaultPic()"
                        class="product-fit-img" fxShow="false" fxShow.gt-md [src]="mainImage"
                        alt="{{product['product']['description']}}" (mousemove)="onMouseMove($event, 3)"
                        (mouseleave)="onMouseLeave($event)" />
                    <lib-ngx-image-zoom *ngIf="product && mainImage !== 'assets/images/no_image_found_md.png' "
                        fxShow="false" fxShow.gt-md [thumbImage]=mainImage [fullImage]=fullImage [magnification]="1.5"
                        [enableScrollZoom]="true" [enableLens]="true" [lensWidth]="200"></lib-ngx-image-zoom>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="!!featureTags && !featureTags['sf_product_img_slider']">
                    <ng-container *ngIf="!!featureTags && featureTags['sf_seo']; else zoomProduct">
                        <img *ngIf="product && mainImage !== 'assets/images/no_image_found_md.png'" class="fit-img cursorAuto" [src]="mainImage"
                            (error)="setDefaultPic()" alt="{{product['product']['description']}}"/>
                        <img *ngIf="product && mainImage === 'assets/images/no_image_found_md.png'" (error)="setDefaultPic()"
                            class="fit-img cursorAuto" [src]="mainImage" alt="{{product['product']['description']}}"/>
                    </ng-container>
                    <ng-template #zoomProduct>
                    <img *ngIf="product" class="zoom fit-img" fxHide="false" fxHide.gt-md [src]="mainImage"
                        (error)="setDefaultPic()" alt="{{product['product']['description']}}"
                        (mousemove)="onMouseMove($event, 3)" (mouseleave)="onMouseLeave($event)" />
                    <img *ngIf="product && mainImage === 'assets/images/no_image_found_md.png'" (error)="setDefaultPic()"
                        class="fit-img" fxShow="false" fxShow.gt-md [src]="mainImage"
                        alt="{{product['product']['description']}}" (mousemove)="onMouseMove($event, 3)"
                        (mouseleave)="onMouseLeave($event)" />
                    <lib-ngx-image-zoom *ngIf="product && mainImage !== 'assets/images/no_image_found_md.png' "
                        fxShow="false" fxShow.gt-md [thumbImage]=mainImage [fullImage]=fullImage [magnification]="1.5"
                        [enableScrollZoom]="true" [enableLens]="true" [lensWidth]="200"></lib-ngx-image-zoom>
                    </ng-template>
                </ng-container>
            </mat-card>
            <div class="small-carousel" *ngIf="product">
                <ng-container *ngIf="!!featureTags && featureTags['ftag_product_images_related_issues']">
                    <div class="swiper-container additional-image-slider" [swiper]="productMainSliderConfig" *ngIf="!!product && !!product.secImages && product.secImages.length > 0">
                        <div class="swiper-wrapper" *ngIf="product">
                            <div *ngFor="let image of product.secImages" class="swiper-slide">
                              <ng-container *ngIf="featureTags && !featureTags['sf_product_img_slider']">
                                <mat-card (click)="selectImage(image)" class="p-1">
                                    <img src="data:," [imgName]="image.medium" imgType="products" imgSize="sm"
                                        class="swiper-lazy strip" ngClass.lt-md="sm" imagePreload
                                        alt="{{product['product']['description']}}" />
                                    <!-- <div class="swiper-lazy-preloader"></div> -->
                                </mat-card>
                              </ng-container>
                              <ng-container *ngIf="featureTags && featureTags['sf_product_img_slider']">
                                <mat-card (click)="selectImage(image)" class="p-1 image-card">
                                    <div class="image-wrapper">
                                      <img src="data:," [imgName]="image.medium" imgType="products" imgSize="sm"
                                        class="swiper-lazy strip-img" ngClass.lt-md="sm" imagePreload
                                        alt="{{product['product']['description']}}"
                                      />
                                    </div>
                                  </mat-card>
                              </ng-container>
                            </div>
                        </div>
                        <button mat-icon-button class="swiper-button-prev swipe-arrow" *ngIf="product.secImages.length > 1">
                            <mat-icon>keyboard_arrow_left</mat-icon>
                        </button>
                        <button mat-icon-button class="swiper-button-next swipe-arrow" *ngIf="product.secImages.length > 1">
                            <mat-icon>keyboard_arrow_right</mat-icon>
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="!!featureTags && !featureTags['ftag_product_images_related_issues']">
                    <div class="swiper-container" [swiper]="config"
                        *ngIf="!!product && !!product.secImages && product.secImages.length > 0">
                        <div class="swiper-wrapper" *ngIf="product">
                            <div *ngFor="let image of product.secImages" class="swiper-slide">
                                <ng-container *ngIf="featureTags && !featureTags['sf_product_img_slider']">
                                    <mat-card (click)="selectImage(image)" class="p-1">
                                        <img src="data:," [imgName]="image.medium" imgType="products" imgSize="sm"
                                            class="swiper-lazy strip" ngClass.lt-md="sm" imagePreload
                                            alt="{{product['product']['description']}}" />
                                        <!-- <div class="swiper-lazy-preloader"></div> -->
                                    </mat-card>
                                  </ng-container>
                                  <ng-container *ngIf="featureTags && featureTags['sf_product_img_slider']">
                                    <mat-card (click)="selectImage(image)" class="p-1 image-card">
                                        <div class="image-wrapper">
                                          <img src="data:," [imgName]="image.medium" imgType="products" imgSize="sm"
                                            class="swiper-lazy strip-img" ngClass.lt-md="sm" imagePreload
                                            alt="{{product['product']['description']}}"
                                          />
                                        </div>
                                      </mat-card>
                                  </ng-container>      
                            </div>
                        </div>
                        <button mat-icon-button class="swiper-button-prev swipe-arrow">
                            <mat-icon>keyboard_arrow_left</mat-icon>
                        </button>
                        <button mat-icon-button class="swiper-button-next swipe-arrow">
                            <mat-icon>keyboard_arrow_right</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
        <div fxFlex="100" fxFlex.gt-md="65" fxFlex.md="55" ngClass.gt-sm="px-3 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2">
            <ng-container *ngIf="!!featureTags && featureTags['sf_seo']; else h2Template">
                <h1 *ngIf="product" style="font-size: 21px;">
                  <span *ngIf="product['description']">{{product['description']}}</span>
                  <span *ngIf="!product['description']">{{product['product']['description']}}</span>
                </h1>
            </ng-container>
            <ng-template #h2Template>
                <h2 *ngIf="product">
                  <span *ngIf="product['description']">{{product['description']}}</span>
                  <span *ngIf="!product['description']">{{product['product']['description']}}</span>
                </h2>
            </ng-template>
            <div class="py-1 lh" *ngIf="product">
                <p><span class="text-muted fw-500">Category:
                    </span><span>{{ product['product']['cb_category']['category_name'] }}</span></p>
            </div>
            <ng-container *ngIf="!!featureTags && !featureTags['sf_product_description_issue']">
                <ng-container *ngIf="!!featureTags && !featureTags['sf_product_description']">
                    <!-- <div class="py-1 lh" *ngIf="productDescription && product">
                        <p><span>{{ productDescription | limitWords }}</span></p>
                    </div> -->
                    <!-- <div class="py-1">
                    </div> -->
        
                    <div class="pd-10 text-muted lh" *ngIf="product"
                    [innerHTML]="product['product']['website_description'] | sanitizeHtml"></div>
                </ng-container>
                <ng-container *ngIf="!!featureTags && featureTags['sf_product_description']">
                    <div class="py-1 lh" *ngIf="productDescription && product">
                        <p><span>{{ productDescription | limitWords }}</span></p>
                    </div>
        
                    <!-- <div class="pd-10 text-muted lh" *ngIf="product"
                        [innerHTML]="product['product']['website_description'] | sanitizeHtml"></div> -->
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!!featureTags && featureTags['sf_product_description_issue']">
                <div class="pd-10 lh website_description_div" *ngIf="product"
                        [innerHTML]="n_productDescription | sanitizeHtml"></div>
            </ng-container>

            <div class="divider mt-1"></div>
            <div *ngIf="product">
                <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change']; else buttonChange">
                    <div *ngIf="product['product']['stock_info']['display_stock']==1" class="stock mt-1">                        
                        <span *ngIf="product['product']['stock_info']['stock_in_hand'] > 0" class="text-muted">
                            Instock: {{ product['product']['stock_info']['stock_in_hand'] }}
                        </span>                                       
                    </div>
                    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                        <div class="priceRow">
                            <h2 class="new-price">
                                {{storeDetails['currency']}}{{product['product']['retail_price'] | number: '1.2-2'}}
                            </h2>
                            <span
                                *ngIf="!!product['product']['cb_unit_of_measurement'] && product && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                                class="perLb-big" style="line-height: normal;">(Per
                                lb)</span>
                            <p class="pd-5 greyText" *ngIf="!!product['product'].compare_price"><span
                                    class="old-price">${{product['product'].compare_price | number : '1.2-2'}} </span>
                                <span class="savedPercentage">Saved ({{product['product'].savepercentage}}%)</span>
                            </p>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="center start" >
                            <p class=" text-muted pd-5"><span class="">{{product['product']['size']}} <span>{{ !!product['product']['size'] && !!product['product']['weight'] ? '/' : '' }}</span> {{product['product']['weight']}}</span> </p>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start" class="actionBtn">
                        <app-controls *ngIf="product" [type]="'dialog'" [product]="product" [store]="storeDetails"
                            [Color]="'#FFF'" [fullBtn]="true" (onOpenProductDialog)="openProductDialog($event,product)">
                        </app-controls>
                    </div>
                </ng-container>
                <ng-template #buttonChange>                    
                    <div *ngIf="product['product']['stock_info']['display_stock'] == 0" class="details text-muted py-1">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxFlex fxLayout="row">
                                <h2 class="mt-1 new-price">
                                    {{storeDetails['currency']}}{{product['product']['retail_price'] | number: '1.2-2'}}
                                </h2>
                                <span
                                    *ngIf="!!product['product']['cb_unit_of_measurement'] && product && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                                    class="perLb-big">(Per
                                    lb)</span>
                                <p class="mt-1 text-muted pd-5" *ngIf="!!product['product'].compare_price"><span
                                        class="old-price">${{product['product'].compare_price | number : '1.2-2'}} </span>
                                    Saved
                                    ({{product['product'].savepercentage}}%)</p>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="center start" >
                                <p class=" text-muted pd-5"><span class="">{{product['product']['size']}} <span>{{ !!product['product']['size'] && !!product['product']['weight'] ? '/' : '' }}</span> {{product['product']['weight']}}</span> </p>
                            </div>
                            
                        </div>
                        <!-- <div class="py-2"> 
                            <h2 class="new-price" *ngIf="product">${{product['product'].retail_price | number: '1.2-2'}}</h2>
                        </div> -->
                        <div fxLayoutAlign="end">
                            <div class="py-1">
                                <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change_part_one']; else buttonChangePartOne">                            
                                    <app-controls *ngIf="product" [type]="'dialog'" [product]="product" [store]="storeDetails"
                                        [Color]="'#FFF'" [fullBtn]="true"
                                        (onOpenProductDialog)="openProductDialog($event,product)"></app-controls>
                                </ng-container>
                                <ng-template #buttonChangePartOne>
                                    <app-controls *ngIf="product" [type]="'dialog'" [product]="product" [store]="storeDetails"
                                        [Color]="'#000'"
                                        (onOpenProductDialog)="openProductDialog($event,product)"></app-controls>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="product['product']['stock_info']['display_stock'] == 1" class="details text-muted py-1">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxFlex fxLayout="row">
                                <h2 class="mt-1 new-price">
                                    {{storeDetails['currency']}}{{product['product']['retail_price'] | number: '1.2-2'}}
                                </h2>
                                <span
                                    *ngIf="!!product['product']['cb_unit_of_measurement'] && product && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                                    class="perLb-big">(Per
                                    lb)</span>
                                <p class="mt-1 text-muted pd-5" *ngIf="!!product['product'].compare_price"><span
                                        class="old-price">${{product['product'].compare_price | number : '1.2-2'}} </span>
                                    Saved
                                    ({{product['product'].savepercentage}}%)</p>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="center start" >
                                <p class=" text-muted pd-5"><span class="">{{product['product']['size']}} <span>{{ !!product['product']['size'] && !!product['product']['weight'] ? '/' : '' }}</span> {{product['product']['weight']}}</span> </p>
                            </div>
                            
                        </div>
                        <!-- <div class="py-2"> 
                            <h2 class="new-price" *ngIf="product">${{product['product'].retail_price | number: '1.2-2'}}</h2>
                        </div> -->
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div *ngIf="product['product']['stock_info']['display_stock']==1" class="stock">
                                <ng-container *ngIf="featureTags['sf_out_of_stock']; else noOutOfStock">
                                    <span *ngIf="product['product']['stock_info']['stock_in_hand'] == 0; else inStock" class="outofstockProduct">
                                      Sold Out
                                    </span>
                                    <ng-template #inStock>
                                      <span>Instock: {{ product['product']['stock_info']['stock_in_hand'] }}</span>
                                    </ng-template>
                                </ng-container>
                                <ng-template #noOutOfStock>
                                    <span>Instock: {{ product['product']['stock_info']['stock_in_hand'] }}</span>
                                </ng-template>
                            </div>

                            <div fxLayoutAlign="end">
                                <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change_part_one']; else buttonChangePartOne">
                                    <app-controls *ngIf="product" [type]="'dialog'" [product]="product" [store]="storeDetails"
                                        [Color]="'#FFF'" [fullBtn]="true"
                                        (onOpenProductDialog)="openProductDialog($event,product)"></app-controls>
                                </ng-container>
                                <ng-template #buttonChangePartOne>
                                    <app-controls *ngIf="product" [type]="'dialog'" [product]="product" [store]="storeDetails"
                                        [Color]="'#000'"
                                        (onOpenProductDialog)="openProductDialog($event,product)"></app-controls>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>


    <div class="second-section-wrapper" *ngIf="loading">
        <div class="item">
            <ngx-skeleton-loader count="3" animation="false" [theme]="{
            height: '50px'
          }"></ngx-skeleton-loader>
        </div>
    </div>



    <div class="DescriptionTabs" *ngIf="!loading && product">
        <mat-tab-group>
            <ng-container *ngIf="!!featureTags && !featureTags['sf_product_tab_image_style']">
                <mat-tab *ngFor="let productTab of productTabs" label="{{productTab['header']}}" class="TabHeader">
                    <ng-template class="TabBodyConent" matTabContent>
                        <span [innerHTML]="productTab['TabContent']"></span>
                    </ng-template>
                </mat-tab>
            </ng-container>
            <ng-container *ngIf="!!featureTags && featureTags['sf_product_tab_image_style']">
                <mat-tab *ngFor="let productTab of productTabs" label="{{productTab['header']}}" class="TabHeader">
                    <ng-template class="TabBodyConent" matTabContent>
                        <span [innerHTML]="sanitizeContent(productTab.TabContent)"></span>
                    </ng-template>
                </mat-tab>
            </ng-container>
            <ng-container *ngIf="!!featureTags && !featureTags['sf_supplier_vendor_to_manufacturer']">
                <mat-tab label="SUPPLIER" class="TabHeader" *ngIf="product && !!product['product']['cb_contact']['vendor_name']">
                    <ng-template class="TabBodyConent" matTabContent>
                        <div class="content container p-20">
                            <div class="row vendor_row p-20">
                                <div class="col-sm-4 col-md-4 p-20">
                                    <div class="SupplierDiv proImg">
                                        <img *ngIf="!!product['product']['cb_contact']['vendor_logo']" class="SupplierImg"
                                            src="data:," [imgName]="product['product']['cb_contact']['vendor_logo']"
                                            alt="{{product['product']['cb_contact']['vendor_name']}}" imgType="vendors" imgSize="md"
                                            imagePreload>
                                        <ng-container *ngIf="!!featureTags && !featureTags['sf_vendor_page_3']">
                                            <span
                                                *ngIf="!!!product['product']['cb_contact']['vendor_logo']">{{product['product']['cb_contact']['vendor_name']}}</span>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 p-20 vendor_descriptionDiv">
                                    <h4>{{product['product']['cb_contact']['vendor_name'] | titlecase}}</h4>
                                    <!-- <div class="underline"></div> -->
                                    <p [innerHTML]="product['product']['cb_contact']['vendor_description']"></p>
                                </div>
                            </div>
                        </div>
                        <!-- {{product['product']['cb_contact']['vendor_name']}}  -->
                    </ng-template>
                </mat-tab>
            </ng-container>
            <ng-container *ngIf="!!featureTags && featureTags['sf_supplier_vendor_to_manufacturer']">
                <mat-tab label="SUPPLIER" class="TabHeader" *ngIf="product && !!product['product']['cb_manufacturer'] && !!product['product']['cb_manufacturer']['name']">
                    <ng-template class="TabBodyConent" matTabContent>
                        <div class="content container p-20">
                            <div class="row vendor_row p-20">
                                <div class="col-sm-4 col-md-4 p-20">
                                    <div class="SupplierDiv proImg">
                                        <img *ngIf="!!product['product']['cb_manufacturer']['logo']" class="SupplierImg"
                                            src="data:," [imgName]="product['product']['cb_manufacturer']['logo']"
                                            alt="{{product['product']['cb_manufacturer']['name']}}" imgType="vendors" imgSize="md"
                                            imagePreload>
                                        <ng-container *ngIf="!!featureTags && !featureTags['sf_vendor_page_3']">
                                            <span
                                                *ngIf="!!!product['product']['cb_manufacturer']['logo']">{{product['product']['cb_manufacturer']['name']}}</span>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 p-20 vendor_descriptionDiv">
                                    <h4>{{product['product']['cb_manufacturer']['name'] | titlecase}}</h4>
                                    <p [innerHTML]="product['product']['cb_manufacturer']['description']"></p>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-tab>
            </ng-container>
        </mat-tab-group>
    </div>

    <div *ngIf="loadingRelatedProduct" class="loading-related-product">
        <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '0', height: '35px', width: '390px' }"></ngx-skeleton-loader>
        <div class="item">
            <ngx-skeleton-loader count="5" appearance="circle" *ngIf="!isMobile"
                [theme]="{width: '150px', height: '150px', 'border-radius': '10px', 'margin-left': '100px'}">
            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="3" appearance="circle" class="mobile-loader-959px" *ngIf="isMobile"
                [theme]="{width: '150px', height: '150px', 'border-radius': '10px', 'margin-left': '100px'}">
            </ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" appearance="circle" class="mobile-loader-400px" *ngIf="isMobile"
                [theme]="{width: '150px', height: '150px', 'border-radius': '10px', 'margin-left': '100px'}">
            </ngx-skeleton-loader>
        </div>
    </div>

    <div *ngIf="!loadingRelatedProduct && relatedProducts && relatedProducts.length > 0"
        class="swiper-container relatedProductsParentDiv" [swiper]="config">
        <h4>CUSTOMERS ALSO ADDED THESE ITEMS</h4>
        <div class="divider"></div>
        <div class="swiper-wrapper h-100 mt-1">
            <div *ngFor="let product of relatedProducts" class="swiper-slide relatedProducts">
                <mat-card class="product-item relatedProductsDiv">
                    <div (click)="openInNewTab(product)">

                        <ng-container *ngIf="!!featureTags && !featureTags['sf_similar_product_img']">
                            <a class="image-link hand">
                                <img src="data:,"
                                    [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                                    imgType="products" class="swiper-lazy hand" imgSize="sm" imagePreload
                                    alt="{{product['product']['description']}}" />
                            </a>
                        </ng-container>
                        <ng-container *ngIf="!!featureTags && featureTags['sf_similar_product_img'] && !featureTags['sf_product_img_slider']">
                            <a class="image-link hand">
                                <img src="data:," 
                                    [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                                    imgType="products" class="swiper-lazy hand mx-height" imgSize="lg" imagePreload
                                    alt="{{product['product']['description']}}" />
                            </a>
                        </ng-container>
                        <ng-container *ngIf="!!featureTags && featureTags['sf_product_img_slider']">
                            <a class="image-link hand">
                                <img src="data:," 
                                    [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                                    imgType="products" class="swiper-lazy hand mx-height" imgSize="md" imagePreload
                                    alt="{{product['product']['description']}}" />
                            </a>
                        </ng-container>
                        <div class="centerView">
                            <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_show_two_line_description_in_product_card']">
                                <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                                    <h3 class="category vendor-name text-muted hand"  *ngIf="product['product'] && (product['product']['manufacturer_name'] || product['product']['vendor_name'])">
                                    {{ product['product']['manufacturer_name'] || product['product']['vendor_name'] }}
                                    </h3>
                                </ng-container>
                                <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                                    <h3 class="category vendor-name text-muted hand" *ngIf="!!product['product']['vendor_name']">
                                        {{ product['product']['vendor_name'] }}</h3>
                                </ng-container>
                                
                            </ng-container>
                            <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_show_two_line_description_in_product_card']">
                                <h3 class="category text-muted hand">
                                    {{ product['product']['cb_category']['category_name'] }}</h3>    
                            </ng-container>
                            <div  class="title text-truncate hand">
                                {{product['product']['description']}}
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="prices hand">
                            <div fxLayout="row" fxLayoutAlign="center start" class="hand">
                                <p class="new-price hand">
                                    {{storeDetails['currency']}}{{product['product'].retail_price | number: '1.2-2'}}
                                </p>
                                <p class=" text-muted pd-l-5  hand" *ngIf="product['product'].compare_price"><span
                                        class="old-price">{{storeDetails['currency']}}{{product['product'].compare_price
                                        | number: '1.2-2'}}</span>
                                    Saved ({{product['product'].savepercentage}}%)</p>
                            </div>
                        </div>
                    </div>

                </mat-card>
            </div>
        </div>
        <div class="swiper-pagination"></div>

        <button mat-mini-fab class="swiper-button-prev swipe-arrow">
            <mat-icon class="icon-align">keyboard_arrow_left</mat-icon>
        </button>
        <button mat-mini-fab class="swiper-button-next swipe-arrow">
            <mat-icon class="icon-align">keyboard_arrow_right</mat-icon>
        </button>
    </div>


    <div fxLayout="row wrap" class="mt-2">
        <div fxFlex="100" fxFlex.gt-md="78" fxFlex.md="74">

        </div>
        <div fxFlex="100" fxFlex.gt-md="22" fxFlex.md="26" ngClass.gt-sm="pl-3" fxHide fxShow.gt-sm>
        </div>
    </div>
    <ng-container *ngIf="!!featureTags && !featureTags['sf_mobile_view_issue_2']">
        <button class="shopping-cart-bar" id="myCart" (click)="goToCart()">
            <span class="total-items">
                <i class="material-icons md-18 mat-icon-sm" data-icon="shopping_basket"></i>
                <span>{{shoppingCartStatusBarData.items}} Items</span>
            </span>
            <span class="total">
                {{storeDetails['currency']}}{{(shoppingCartStatusBarData.total | number: '1.2-4' | replacecomma) | number:
                '1.2-2'}}
            </span>
        </button>
    </ng-container>
</div>